import ActionType from 'actions/ActionType'

export default (state = null, action) => {
  switch (action.type) {
    case ActionType.Campaign.EXPAND_FUNNEL_STAGE:
      return action.payload
    // case ActionType.Campaign.RECEIVE_CAMPAIGN:
    //   return null
    case ActionType.Campaign.ADD_OR_EDIT_EVENT_GOAL:
      return action.payload.stage
    default:
      return state
  }
}
